import React, { Component } from "react";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import "./../../../View.css";
import "./../../../Grid.css";
import "./../../../Form.css";
import "./../../../App.css";
import SearchView from "../../../widgets/SearchView";
import LearningAreaSetupSearchForm from './../LearningArea/LearningAreaSetupSearchForm';
import { ViewContainer } from "./../../../View.jsx";
import ViewUtils from "./../../../ViewUtils";
import withMenuPermission from "../../../widgets/withMenuPermission";


const headCells = [
    { id: 'LearningAreaCode', numeric: false, disablePadding: true, label: 'Learning Area Code' },
    { id: 'LearningAreaTitle', numeric: false, disablePadding: true, label: 'Learning Area Title' }
];

const searchParameters = [
    { Name: "LearningAreaCode", Value: "" },
    { Name: "LearningAreaTitle", Value: "" }
];

const utils = new ViewUtils();

class LearningAreaSetupSearch extends Component {
    constructor(props) {
        super(props)

        this.state = {
            model: {
                LearningAreaCode: "",
                LearningAreaTitle: ""
            },
            selectedLearningArea: null,
            keyUpSwitch: false
        }

        this.toolbarConfig = {
            items: [
                {
                    type: "buttonGroup",
                    buttons: [
                        { id: 'add', label: '', tooltip: 'Add', icon: 'AddIcon', visible: this.props.menuPermissionItem.Add },
                        { id: 'edit', label: '', tooltip: 'Edit', icon: 'EditIcon', disabled: true, visible: this.props.menuPermissionItem.Edit },
                        { id: "delete", label: '', tooltip: 'Remove AET', icon: 'DeleteIcon', disabled: true, visible: this.props.menuPermissionItem.Delete }
                    ]
                }
            ]
        }
    }

    onkeyup(e) {
        //console.log(e.charCode)
        if (e.charCode == 13) {
            this.setState({ keyUpSwitch: !this.state.keyUpSwitch })
        }
    }

    render() {
        return (
            <ViewContainer title="">
                <SearchView headCells={headCells} dataUrl={!utils.isNull(this.props.dataUrl) ? this.props.dataUrl : "api/sims/LearningAreasetup/getsearch"}
                    entityViewPath='/learningareaSetup'
                    title='Learning Area'
                    model={this.state.model} toolbarConfig={this.toolbarConfig}
                    searchParameters={searchParameters} onLookupValueChange={this.props.onLookupValueChange}
                    descriptionProp="LearningAreaTitle" mode={this.props.mode}
                    keyUpSwitch={this.state.keyUpSwitch}
                    history={this.props.history}
                    multiSelect={this.props.multiSelect}
                    deleteUrl={"api/sims/LearningAreaSetup/RemoveLearningArea"} useDeletePost={true}
                    promptTitle={"Remove Learning Area"} selectionCallbackMode={this.props.selectionCallbackMode}
                    promptContent={"Removing the Learning Area is a permanent action and the Learning Area will not be available going forward. Are you sure you want to remove this Learning Area?"}
                >
                    <LearningAreaSetupSearchForm
                        data={this.state.model}
                        onKeyUp={(e) => { this.onkeyup(e) }}
                        valueChangeHandler={(values) => {
                            if (JSON.stringify(this.state.model) !== JSON.stringify(values)) {
                                this.setState({ model: values });
                            }
                        }}
                    />
                </SearchView>
            </ViewContainer>

        );
    }
}

export default withRouter(withMenuPermission(LearningAreaSetupSearch));

